export default "__VITE_ASSET__CmF5_82M__"